import { useMutation } from '@apollo/client/react';
import { useResetAtom } from 'jotai/utils';
import React, { useCallback, useEffect } from 'react';

import { Alert, Button, Modal, Text } from '~/components/blocks';
import {
  ForbidAccessPermissionDocument,
  GetAccessPermissionDocument,
} from '~/graphql/generated/graphql';
import { permissionModalState } from '~/state/layouts/OrganizationAppShell/atoms';
import { Label } from '~/utils/label';

type Props = {
  expiredAt: string;
};

export const ForbidPane = (props: Props) => {
  const resetPermissionModalState = useResetAtom(permissionModalState);
  const [forbidAccessPermission, { data, error, loading }] = useMutation(
    ForbidAccessPermissionDocument,
    {
      refetchQueries: [{ query: GetAccessPermissionDocument }],
    },
  );

  useEffect(() => {
    if (data?.cancelOperatorAccessPermission) {
      resetPermissionModalState();
    }
  }, [data, resetPermissionModalState]);
  const handleClick = useCallback(() => {
    forbidAccessPermission({ variables: { input: {} } });
  }, [forbidAccessPermission]);

  return (
    <>
      <Modal.Body>
        {error && <Alert status="error">エラーが発生しました</Alert>}
        <Text>{Label.YYYYMMDDja(props.expiredAt)}までアクセスを許可</Text>
      </Modal.Body>
      <Modal.Footer>
        <Button use="base" loading={loading} onClick={handleClick}>
          取り消す
        </Button>
      </Modal.Footer>
    </>
  );
};
